import { shared_en_resources } from './en'
import { shared_zh_resources } from './zh'

export * from './en'
export * from './zh'

export const resources = {
  en: shared_en_resources,
  zh: shared_zh_resources,
}
